// Curated, grass-matched seed + starter picks for the seeding calculator.
// "The seed for YOUR grass" instead of a generic category block: maps the
// result's grass type to that species' seed in the shared catalog
// (data/guide-product-recommendations.ts) plus a starter-fertilizer companion.
// Mirrors lib/soil-test/product-picks.ts via the shared resolver.
//
// The grass -> seed map itself lives in lib/product-picks/seed-by-grass.ts so the
// grass-comparison tool can reuse the same enthusiast-grade picks. St. Augustine
// is intentionally unmapped there (sod/plugs, not seed), so this returns [] for it
// and the page falls back to the generic block.

import type { ProductRecommendationLink } from '@/lib/product-picks/types'
import { resolvePicks } from '@/lib/product-picks/resolve'
import { SEED_BY_GRASS, STARTER, normalizeGrass } from '@/lib/product-picks/seed-by-grass'

/**
 * Curated seed + starter picks matched to the seeding result's grass type.
 * Returns [] for grasses with no seed product (e.g. St. Augustine) so the caller
 * can fall back to the generic block. Pure.
 */
export function getSeedingPicks(result: { grassType: string }): ProductRecommendationLink[] {
  const seed = SEED_BY_GRASS[normalizeGrass(result.grassType)]
  if (!seed) return []
  return resolvePicks([seed, STARTER])
}
